import * as tslib_1 from "tslib";
import { css } from '../../styles';
var widthPropReceiver = function (props) {
    return typeof props.width !== 'undefined' && css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ",
        ";\n  "])), typeof props.width === 'number'
        ? props.width + "px"
        : props.width);
};
export default widthPropReceiver;
var templateObject_1;
//# sourceMappingURL=width.js.map